import { createRoot } from 'react-dom/client'
// import { ErrorBoundary } from 'react-error-boundary'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import { ThemeProvider } from '@mui/material'
import { GlobalStyles, CssVarsProvider, CssBaseline } from '@mui/joy'
import { THEME_ID } from '@mui/joy/styles'
import { store } from 'app/store'
import myAppTheme, { materialTheme } from 'theme'
import router from 'views/Router'

const container = document.getElementById('root')
const notistackContainer = document.getElementById('notistack-portal')

const root = createRoot(container)

root.render(
  <Provider store={store}>
    <ThemeProvider theme={materialTheme}>
      <CssVarsProvider theme={{ [THEME_ID]: myAppTheme }}>
        <CssBaseline />
        <GlobalStyles
          styles={(theme) => ({
            '#root': {
              position: 'relative',
              zIndex: 1,
            },
            ':root': {
              '--Form-maxWidth': '800px',
              '--Transition-duration': '0.4s',
              '--Header-height': '52px',
              '--Sidebar-width': '220px',
              '--joy-zIndex-modal': '15000',
              '--joy-zIndex-tooltip': '14000',
            },
            [theme.breakpoints.up('md')]: {
              '--Header-height': '0px',
            },
            [theme.breakpoints.up('lg')]: {
              '--Sidebar-width': '240px',
            },
            '.MuiListItemButton-root.active': {
              backgroundColor: `${theme.palette.neutral.plainActiveBg}`,
            },
            '.MuiPopper-root.MuiPickersPopper-root': {
              zIndex: '19000',
            },
            '.notistack-index-must-go-brr': {
              zIndex: '20000',
            },
            '.joy-custom-picker .clearButton': {
              opacity: '1 !important',
            },
            '.joy-custom-picker': {
              '.MuiInput-input': {
                textTransform: 'lowercase',
                '&::placeholder': {
                  textTransform: 'lowercase',
                },
              },
            },
          })}
        />
        <SnackbarProvider
          domRoot={notistackContainer}
          classes={{ containerRoot: 'notistack-index-must-go-brr' }}
          maxSnack={5}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <RouterProvider router={router} />
        </SnackbarProvider>
      </CssVarsProvider>
    </ThemeProvider>
  </Provider>
)
